import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';

const minTariffsWithAds: undefined | 'a' | 'b' = getFeature('min-tariffs-with-ads');
export const isMinTariffsWithAds = minTariffsWithAds === 'b';

export const minTariffsWithAdsMobile: YearAndMonthProductIds = !IS_WEBVIEW && getFeature('min-tariffs-with-ads-touch');
